module.exports = {"forma-equipos":"Forma dos equipos","continuar":"Continuar","azul":"Azul","naranja":"Naranja"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/init/es.json
// module id = 178
// module chunks = 7